export default __webpack_public_path__ + "static/media/Horizontals.5df7ca82.svg";